import { getMonthsRangeDuration, MonthsRange } from '@wrisk/ui-components'

import { required } from '../helpers'
import { ValidationFunctions } from '../types'

export const monthsRange: ValidationFunctions = {
  _self: {
    required,
    minDuration: (minDuration: number) => (value: MonthsRange) => {
      const duration = getMonthsRangeDuration(value)
      return duration === 0 || duration >= minDuration
    },
    maxDuration: (maxDuration: number) => (value: MonthsRange) => {
      const duration = getMonthsRangeDuration(value)
      return duration === 0 || duration <= maxDuration
    },
  },
}
